// src/components/EmergencyPhoneCTA.jsx
import React from 'react';
import { Phone, AlertOctagon } from 'lucide-react';
import { useLang, tx } from '../context/LanguageContext';
import CallbackB2BForm from './CallbackB2BForm';

export default function EmergencyPhoneCTA({ treePath }) {
  const { lang } = useLang();
  return (
    <div className="space-y-6">
      <div className="bg-red-500/10 border border-red-500/30 rounded-2xl p-6 md:p-8">
        <div className="flex items-start gap-4 mb-4">
          <AlertOctagon className="w-10 h-10 text-red-400 flex-shrink-0" />
          <div>
            <h3 className="text-2xl font-bold text-white">
              {tx(lang, 'Urgence informatique ?', 'IT emergency?', { es: '¿Emergencia informática?', de: 'IT-Notfall?', it: 'Emergenza informatica?', pt: 'Emergência informática?' })}
            </h3>
            <p className="text-slate-300 mt-1">
              {tx(lang,
                'Appelez-nous directement, intervention sous 4 h ouvrées.',
                'Call us directly, intervention within 4 business hours.',
                {
                  es: 'Llámenos directamente, intervención en 4 horas laborables.',
                  de: 'Rufen Sie uns direkt an, Eingriff innerhalb von 4 Arbeitsstunden.',
                  it: 'Chiamateci direttamente, intervento entro 4 ore lavorative.',
                  pt: 'Ligue-nos directamente, intervenção em 4 horas úteis.',
                })}
            </p>
          </div>
        </div>
        <a href="tel:0183623327"
           className="inline-flex items-center gap-3 bg-red-500 hover:bg-red-600 text-white font-bold text-xl md:text-2xl py-4 px-8 rounded-xl transition-all">
          <Phone className="w-6 h-6" />
          01 83 62 33 27
        </a>
      </div>

      <div className="flex items-center gap-4 text-slate-500 text-sm">
        <div className="flex-1 h-px bg-white/10" />
        <span>
          {tx(lang,
            'ou hors horaires / impossible d\'appeler',
            'or out of hours / unable to call',
            {
              es: 'o fuera de horas / no puede llamar',
              de: 'oder außerhalb der Geschäftszeiten / nicht erreichbar',
              it: 'o fuori orario / impossibile chiamare',
              pt: 'ou fora de horas / não pode ligar',
            })}
        </span>
        <div className="flex-1 h-px bg-white/10" />
      </div>

      <p className="text-slate-300 text-center">
        {tx(lang, 'Demandez un rappel prioritaire :', 'Request a priority callback:', {
          es: 'Solicite una llamada prioritaria:',
          de: 'Fordern Sie einen Prioritätsrückruf an:',
          it: 'Richiedete una richiamata prioritaria:',
          pt: 'Solicite uma chamada prioritária:',
        })}
      </p>
      <CallbackB2BForm contextTag="urgence" treePath={treePath} />
    </div>
  );
}
